// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductCatalogsState } from "@store/Framework/Store/Store/Data/ProductCatalogs/ProductCatalogsState";
import { ProductCatalogModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: ProductCatalogsState = {
    isLoading: false,
};

const actions = {
    "Store/Data/ProductCatalogs/BeginGetCatalog": (draft: Draft<ProductCatalogsState>) => {
        draft.isLoading = true;
    },
    "Store/Data/ProductCatalogs/CompleteGetCatalog": (draft: Draft<ProductCatalogsState>, action: { result: any }) => {
        draft.isLoading = false;
        draft.catalog = action.result;
    },
    "Store/Data/ProductCatalogs/BeginLoadProductCatalogs": (draft: Draft<ProductCatalogsState>) => {
        draft.isLoading = true;
    },
    "Store/Data/ProductCatalogs/CompleteLoadProductCatalogs": (
        draft: Draft<ProductCatalogsState>,
        action: { result: ProductCatalogModel },
    ) => {
        draft.isLoading = false;
        draft.priceTypes = action.result.priceTypes;
    },
    "Store/Data/ProductCatalogs/BeginLoadGeneralDocuments": (draft: Draft<ProductCatalogsState>) => {
        draft.isLoading = true;
    },
    "Store/Data/ProductCatalogs/CompleteLoadGeneralDocuments": (
        draft: Draft<ProductCatalogsState>,
        action: { result: string[] },
    ) => {
        draft.isLoading = false;
        draft.generalDocuments = action.result;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreProductCatalogsActions = Parameters<typeof reducer>[1];
export default reducer;
